<div *ngIf="isLoading | async" class="loader-overlay">
    <mat-progress-spinner class="spinner" mode="indeterminate" color="accent" diameter="70"></mat-progress-spinner>
</div>
